import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"
import { cn } from "../../lib/utils"
const resolveDocumentDir = (): "ltr" |"rtl"=> {
 if (typeof document === "undefined") return"rtl"
return document.documentElement.dir === "ltr"? "ltr":"rtl"}

const Popover = PopoverPrimitive.Root
const PopoverTrigger = PopoverPrimitive.Trigger

type PopoverContentProps = React.ComponentPropsWithoutRef<
 typeof PopoverPrimitive.Content
> &
 Pick<React.HTMLAttributes<HTMLDivElement>,"dir">

const PopoverContent = React.forwardRef<
 React.ElementRef<typeof PopoverPrimitive.Content>,
 PopoverContentProps
>(({ className, align ="center", sideOffset = 6, ...props }, ref) => (
 <PopoverPrimitive.Portal>
 <PopoverPrimitive.Content
 ref={ref}
 align={align}
 sideOffset={sideOffset}
 className={cn(
"z-50 w-72 rounded-md border border-border bg-popover p-3 text-popover-foreground shadow-premium-md outline-none",
" data-[state=open]:animate-in data-[state=closed]:animate-out",
" data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
" data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
" data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
 className
 )}
 {...{ dir: resolveDocumentDir(), ...props }}
 />
 </PopoverPrimitive.Portal>
))
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent }

